import PurchaseSuccessPage from 'containers/purchase-success'

export default PurchaseSuccessPage
